import React, { useMemo } from 'react';
import { TypedMemo } from '../../../common/types';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { catalogArtworkSrc } from '../../../smartLinks/catalog/catalogArtwork';

interface ReleaseArtworkProps {
  item: CatalogItem;
  className?: string;
  /** The size of the cover on the page in CSS px; imgproxy makes the picture for it. */
  sizePx?: number;
}

/** The cover of a catalog row, or a tile with the first two letters of the title when it has none. */
const ReleaseArtworkComponent: React.FC<ReleaseArtworkProps> = ({ item, className, sizePx = 64 }) => {
  const src = catalogArtworkSrc(item, sizePx);
  const letters = useMemo(() => item.title.trim().slice(0, 2).toUpperCase(), [item.title]);

  if (src !== undefined) {
    return <img className={className} src={src} alt="" />;
  }
  return (
    <span className={className} aria-hidden="true">
      {letters}
    </span>
  );
};

export const ReleaseArtwork = TypedMemo(ReleaseArtworkComponent);
